import {
  BaseInputProps, ErrorsWrapper,
  NumberInput,
  RelativeRow,
  TextInput, useFormContextRequired,
  useInputHelper
} from 'ui-builder';
import { AbstractTask, ParentTaskRelation } from 'nekst-api';
import React from 'react';

interface DisabledTaskNameInputProps extends BaseInputProps<ParentTaskRelation> {

}

function DisabledTaskNameInput(props: DisabledTaskNameInputProps) {
  const helper = useInputHelper<ParentTaskRelation>(props);

  return (
    <TextInput
      label={props.label}
      source={`${props.source}.name`}
      value={helper.getValue().parentTaskName}
      onChangeCallback={() => {
        // ignored
      }}
      isDisabled
    />
  );
}

export function ProjectParentTaskRelationInput(props: {
  source: string;
  label: string;
}) {
  const formContext = useFormContextRequired<AbstractTask>();

  const isProceeding = formContext.data?.parentTaskRelation?.isProceeding;

  return (
    <ErrorsWrapper name="parentTaskRelation.days">
      <RelativeRow weights={[3, 9]} useFlex toBottom>
        <NumberInput source={`${props.source}.days`} label={props.label} hideValidationErrors />
        <DisabledTaskNameInput
          source={`${props.source}`}
          label={isProceeding ? 'Days Before Task Due Date' : 'Days After This Task Completion'}
        />
      </RelativeRow>
    </ErrorsWrapper>

  );
}
